import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TableContainer from "../../components/layout/table-container/table-container";
import { superAdminVersionList } from "../../redux/actions/superAdminActions";
import SuperUserVersionTableData from "./super-user-version-table-data";
import LoadingSpinnerTable from "../../components/utilites/loaderSpinningContainer";
import NumberPagination from "../../components/Pagination/number-pagination";

const SuperUserVersionTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [superVersionListData, setSuperVersionListData] = useState([]);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [loading, setLoading] = useState(false);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    dispatch(superAdminVersionList({ search, page }, onSuccess, onError));
  }, [page, search]);

  const onSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data);
    setSuperVersionListData(data.data.data);
  };

  const onError = (err) => {
    console.log(err);
    setLoading(false);
  };

  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>
            <th className="table-heads " width={"10%"}>
              Employee ID
            </th>
            <th className="table-heads " width={"10%"}>
              Name
            </th>
            <th className="table-heads " width={"10%"}>
              Email Address
            </th>
            <th className="table-heads " width={"10%"}>
              Phone Number
            </th>
            <th className="table-heads " width={"10%"}>
              Updated By
            </th>
            <th className="table-heads " width={"12%"}>
              Updated Date
            </th>

            <th className="table-heads " width={"15%"}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody style={{ position: "relative" }}>
          {loading == true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable show={loading} />
            </div>
          ) : superVersionListData?.superAdmins?.length > 0 ? (
            <>
              {superVersionListData?.superAdmins?.map((eachRow, index) => (
                <SuperUserVersionTableData
                  key={eachRow.id}
                  data={eachRow}
                  index={index}
                  currentPage={superVersionListData?.pagination?.currentPage}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="1" className="text-center no-data-container fs_16">
                <span>~ No Data Found ~</span>
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
      {superVersionListData?.pagination?.totalPages > 0 && (
        <NumberPagination
          setCurrentPage={setPage}
          pagination={superVersionListData?.pagination?.currentPage}
          totalPages={superVersionListData?.pagination?.totalPages}
          path={"/super-user/user"}
          filters={`${queryString}`}
        />
      )}
    </>
  );
};

export default SuperUserVersionTable;
